var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-results d-inline-block"},[_c('b-button',{staticClass:"bg-transparent border-0 shadow-none p-0",attrs:{"id":"download-results-btn"},on:{"click":_vm.downloadResults}},[_c('i',{staticClass:"fa fa-download",attrs:{"aria-hidden":"true"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }